<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pt-3 tw-pb-3.5">
        <base-breadcrumbs :breadcrumbs="breadcrumbs" />
      </base-content>
      <base-content class="tw-pt-0 tw-pb-0">
        <div class="tw-flex tw-justify-between">
          <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-my-auto tw-font-thin">Team Members</h1>
          <base-button class="tw-my-auto" @click="invite">
            <template v-slot:icon>
              <plus-icon />
            </template>
            Invite Team Member
          </base-button>
        </div>
        <base-tabs class="tw-mt-2 tw-pb-4 md:tw-pb-0 tw-mb-0" no-border @click="tabClick($event)">
          <base-tab :selected="$route.meta.component === 'BusinessUsers'" title="Team Members" />
          <base-tab :selected="$route.meta.component === 'BusinessUserInvites'" title="Invites" />
        </base-tabs>
      </base-content>
    </div>
    <base-content>
      <keep-alive>
        <component :is="currentComponent" :business-id="businessId" />
      </keep-alive>
    </base-content>
    <business-user-invite-slideover :businessId="businessId" ref="invitemodal" />
  </div>
</template>

<script>
import BusinessUserInviteSlideover from "@/views/business/business-users/components/BusinessUserInviteSlideover";
import { PlusIcon } from "@/assets/svgs";

export default {
  name: "BusinessUsersView",
  components: {
    PlusIcon,
    BusinessUserInviteSlideover,
    BusinessUsers: () => import("@/views/business/business-users/BusinessUsers.vue"),
    BusinessUserInvites: () => import("@/views/business/business-users/BusinessUserInvites.vue"),
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      component: "BusinessUsers",
      tabs: [{ label: "Team Members", component: "BusinessUsers", route: "users" }, { label: "Invites", component: "BusinessUserInvites", route: "invites" }],
    };
  },
  computed: {
    breadcrumbs() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return [{ title: "Settings", onClick: () => this.$router.push(`/businesses/${this.businessId}/business`) }, { title: "Team Members" }];
    },
    currentComponent() {
      return this.$route.meta.component;
    },
  },
  methods: {
    invite() {
      this.$refs.invitemodal.show();
    },
    href(path) {
      if (this.$route.path !== path) {
        this.$router.push({
          path,
          params: { businessId: this.businessId },
        });
      }
    },
    tabClick(tabTitle) {
      const tab = this.tabs.find((t) => t.label === tabTitle);
      this.href(`/businesses/${this.businessId}/business/users/${tab.route}`);
    },
  },
};
</script>
